/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CheckoutDraft } from './CheckoutDraft';
import {
    CheckoutDraftFromJSON,
    CheckoutDraftFromJSONTyped,
    CheckoutDraftToJSON,
} from './CheckoutDraft';

/**
 * 
 * @export
 * @interface CalculateCheckout201ResponseAllOfData
 */
export interface CalculateCheckout201ResponseAllOfData {
    /**
     * 
     * @type {CheckoutDraft}
     * @memberof CalculateCheckout201ResponseAllOfData
     */
    checkout: CheckoutDraft;
}

/**
 * Check if a given object implements the CalculateCheckout201ResponseAllOfData interface.
 */
export function instanceOfCalculateCheckout201ResponseAllOfData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "checkout" in value;

    return isInstance;
}

export function CalculateCheckout201ResponseAllOfDataFromJSON(json: any): CalculateCheckout201ResponseAllOfData {
    return CalculateCheckout201ResponseAllOfDataFromJSONTyped(json, false);
}

export function CalculateCheckout201ResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalculateCheckout201ResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'checkout': CheckoutDraftFromJSON(json['checkout']),
    };
}

export function CalculateCheckout201ResponseAllOfDataToJSON(value?: CalculateCheckout201ResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'checkout': CheckoutDraftToJSON(value.checkout),
    };
}

